// Generated from packages/shared/design-tokens/core.json. Run pnpm tokens:build; do not edit.
export const PALETTE = {
    "brand": {
        "primary": "#3468F8",
        "hover": "#2952d6"
    },
    "severityText": {
        "critical": "#991B1B",
        "high": "#9a3412",
        "medium": "#854d0e",
        "low": "#4b5563"
    },
    "neutral": {
        "50": "#f9fafb",
        "100": "#f3f4f6",
        "200": "#e5e7eb",
        "300": "#cfcfcf",
        "400": "#6b7280",
        "500": "#6b7280",
        "600": "#4b5563",
        "700": "#374151",
        "800": "#1f2937",
        "900": "#141414",
        "950": "#030712"
    },
    "surface": {
        "page": "#ffffff",
        "card": "#ffffff",
        "subtle": "#f9fafb",
        "hover": "#f3f4f6",
        "border": "#e5e7eb",
        "dark": "#141414",
        "darkBorder": "#374151",
        "darkText": "#f3f4f6",
        "darkMuted": "#cfcfcf"
    },
    "primary": {
        "25": "#f7f9ff",
        "50": "#eff4ff",
        "100": "#dbe6ff",
        "200": "#bfd2ff",
        "300": "#93b4ff",
        "400": "#6090ff",
        "500": "#3468F8",
        "600": "#2952d6",
        "700": "#2142ab",
        "800": "#1a3587",
        "900": "#162d6b",
        "950": "#0e1c42"
    }
};
/** Resolved rgba works in browser styles and email without CSS variables. */
export function paletteRgba(color, alpha) {
    return 'rgba(' + [1, 3, 5].map(i => parseInt(color.slice(i, i + 2), 16)).join(', ') + ', ' + alpha + ')';
}
//# sourceMappingURL=designPalette.js.map